import { Collapse } from "@mui/material";
import React, { useEffect, useState } from "react";
import MyTable from "./MyTable";
import { ArrowDropDownIcon } from "@mui/x-date-pickers";
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';
import { Col, Row } from "react-bootstrap";

export default function CollapseComponent({ rows, columns, name, checkboxSelection = true, mode2 ,
  isRowSelectable , rowSelectionModel = false, onRowSelectionModelChange = () => { }, open = false, height = '30px',
  onExpandChange = () => { }, onRowClick = () => { }, onOpenModal = () => { }, showHeader = true, isShowMoreData = false ,
  showAllColumn = false, rowCount , is_dn_deparment,setIsNightShift = () => { } }) {
  const [expanded, setExpanded] = useState(true);

  useEffect(() => {
    if (open) {
      setExpanded(true)
    }
    else {
      setExpanded(false)
    }
  }, [open])

  useEffect(() => {
    if (expanded) {
      onExpandChange(true);
    }
    else {
      onExpandChange(false);
    }
  }, [expanded]);


  return (
    <>
      <button
        className="w-100 text-dark d-flex justify-content-between  p-2 border-0 my-2"
        style={{ backgroundColor: '#BF1D2D' }}
        onClick={() => setExpanded((pre) => !pre)}
      >
        {is_dn_deparment == 'DN_TOGGLE' && 
          <Col className="d-flex justify-content-left" md={mode2 === '24' ? 5 : 4}>
            <span className=" text-white" style={{ fontWeight: "400" }}>{name}</span>
          </Col>
        }
        {is_dn_deparment == 'DN_24_VIEW' && 
          <Col className="d-flex justify-content-left" md={3}>
            <span className=" text-white" style={{ fontWeight: "400" }}>{name}</span>
          </Col>
        }
        {is_dn_deparment == '24_FULL_VIEW' && 
          <Col className="d-flex justify-content-left" md={2}>
            <span className=" text-white" style={{ fontWeight: "400" }}>{name}</span>
          </Col>
        }
        {is_dn_deparment == undefined &&
          <Col className="d-flex justify-content-left" md={3}>
            <span className=" text-white" style={{ fontWeight: "400" }}>{name}</span>
          </Col>
        }
        {!showHeader &&
          <>
            <Col className="d-flex justify-content-left" md={3}>
              <span className=" text-white " style={{ fontWeight: "400" }}>{columns[1].headerName}</span>
            </Col>
            <Col className="d-flex justify-content-center" md={3}>
              <span className=" text-white " style={{ fontWeight: "400" }}>{columns[2].headerName}</span>
            </Col>
            {showAllColumn &&
              <Col className="d-flex justify-content-center" md={3}>
                <span className=" text-white " style={{ fontWeight: "400" }}>{columns[3].headerName}</span>
              </Col>
            }
          </>
        }
				{isShowMoreData &&
					<div style={{
						marginBottom: "0px",
						marginLeft: '70%',
						height: '24px',
						width: '24px',
						borderRadius: '50%',
						backgroundColor: '#ffffff',
						display: 'flex',
						alignItems: 'center',
						justifyContent: 'center',
					}}>
						<p style={{ fontSize: '13px', fontWeight:'550' , margin: 0 , color:'#000000' }}>
							{rowCount}
						</p>
					</div>
				}
        <p style={{ marginBottom: "0px" }} className="text-end text-white col-md-auto">
          {expanded ? <ArrowDropUpIcon /> : <ArrowDropDownIcon />}
        </p>
      </button>
      <Collapse in={expanded} timeout="auto" unmountOnExit={false} >
        <MyTable
          rows={rows}
          columns={columns}
          isCollapse={true}
          useTopFilter={false}
          hideFooter={true}
          height={height}
          checkboxSelection={checkboxSelection}
					isRowSelectable={isRowSelectable} 
          selectedRows={rowSelectionModel}
          onRowSelectionModelChange={onRowSelectionModelChange}
          onRowClick={onRowClick}
          onOpenModal={onOpenModal}
          showHeader={showHeader}
          setIsNightShift={setIsNightShift}
        />
      </Collapse>
    </>
  );
}
